import React, { useEffect, useState } from "react";
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../../appConstants";
import { Button, Switch, Tooltip } from "@mui/joy";
import Icon from "../../../svg/Ads Dashboard Development/Small/elements.svg";
import DateIcon from "../../../svg/Ads Dashboard Development/DateIcon/elements.svg";
import DragAndDropIcon from "../../../svg/Ads Dashboard Development/Drag_and_Drop_Icon/elements.svg";
import { Outlet, useFetcher, useLocation, useNavigate } from "react-router-dom";
import DateRangeComponent from "../../commonComponents/DateRangeComponent/DateRangeComponent";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid

import { useSelector } from "react-redux";
import axios from "axios";
import appError from "../../../appError";
import { formatToDDMMYYYY } from "../../../appFunctions";

type DateRange = {
  start: Date;
  end: Date;
};
type DataProps = {
  id: number;
  matrices: string;
  base_period: Number;
  comparison_period: Number;
  difference: Number;
};
type Matrice = {
  id: number;
  matrice: string;
  toggle: boolean;
  position: number;
};
const Comparison: React.FC = () => {
  const getMatricesData = localStorage.getItem(
    "AdsOverviewComparisonTableSelectedMatrices"
  );
  const [matricesData, setMatricesData] = useState<Matrice[]>(
    getMatricesData
      ? JSON.parse(getMatricesData)
      : [
          { id: 1, matrice: "Impressions", toggle: true, position: 0 },
          { id: 2, matrice: "Clicks", toggle: true, position: 1 },
          { id: 3, matrice: "Spend", toggle: true, position: 2 },
          { id: 4, matrice: "Sales", toggle: true, position: 3 },
          { id: 5, matrice: "Units", toggle: true, position: 4 },
        ]
  );
  const location = useLocation();
  const navigate = useNavigate();
  const full_name = localStorage.getItem("full_name");
  const words: string[] = full_name ? full_name.split(" ") : [" "];
  const [baseDate, setBaseDate] = useState<DateRange>({
    start: new Date("Fri Nov 01 2024 00:00:00 GMT+0530 (India Standard Time)"),
    end: new Date("Fri Nov 30 2024 00:00:00 GMT+0530 (India Standard Time)"),
  });
  const [ComparisonDate, setComparisonDate] = useState<DateRange>({
    start: new Date("Fri Oct 01 2024 00:00:00 GMT+0530 (India Standard Time)"),
    end: new Date("Fri Oct 30 2024 00:00:00 GMT+0530 (India Standard Time)"),
  });
  const [BrandRange, setBrandRange] = useState<string | null>(
    localStorage.getItem("BrandRange")
  );
  type RangeProps = {
    min_date: Date;
    max_date: Date;
  };
  const [range, setRange] = useState<RangeProps>({
    min_date: new Date(
      BrandRange && JSON.parse(BrandRange).min_date.split("T")[0]
    ),
    max_date: new Date(
      BrandRange && JSON.parse(BrandRange).max_date.split("T")[0]
    ),
  });
  const { brand_id } = useSelector((state: any) => state.appData);
  const [datename, setdatename] = useState<string>("");
  const apply = (initialdata: any) => {
    if (datename === "BASE") {
      setBaseDate((prev) => ({
        ...prev,
        ["start"]: new Date(initialdata?.startDate),
        ["end"]: new Date(initialdata?.endDate),
      }));
    } else {
      setComparisonDate((prev) => ({
        ...prev,
        ["start"]: new Date(initialdata?.startDate),
        ["end"]: new Date(initialdata?.endDate),
      }));
    }
  };
  const [rowsToggle, setRowsToggle] = useState<boolean>(false);
  const columnDefs: ColDef<DataProps>[] = [
    { field: "matrices", headerName: "Matrices" },
    { field: "base_period", headerName: "Base Period" },
    { field: "comparison_period", headerName: "Comparison Period" },
    { field: "difference", headerName: "Difference" },
  ];

  const [initialdata, setInitialData] = useState<DataProps[]>([]);
  const [filterdata, setfilterData] = useState<DataProps[]>([...initialdata]);
  const [rowsdata, setRowsData] = useState<DataProps[]>([]);

  const onSaveFilterHandler = async () => {
    let filter = {
      range_one: {
        start_date: `${baseDate?.start.getFullYear()}-${String(
          baseDate?.start.getMonth() + 1
        ).padStart(2, "0")}-${String(baseDate?.start.getDate()).padStart(
          2,
          "0"
        )}`,
        end_date: `${baseDate?.end.getFullYear()}-${String(
          baseDate?.end.getMonth() + 1
        ).padStart(2, "0")}-${String(baseDate?.end.getDate()).padStart(
          2,
          "0"
        )}`,
      },
      range_two: {
        start_date: `${ComparisonDate?.start.getFullYear()}-${String(
          ComparisonDate?.start.getMonth() + 1
        ).padStart(2, "0")}-${String(ComparisonDate?.start.getDate()).padStart(
          2,
          "0"
        )}`,
        end_date: `${ComparisonDate?.end.getFullYear()}-${String(
          ComparisonDate?.end.getMonth() + 1
        ).padStart(2, "0")}-${String(ComparisonDate?.end.getDate()).padStart(
          2,
          "0"
        )}`,
      },
    };
    const token = localStorage.getItem("token");
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getComparasionOfTwoRange?brand_id=${brand_id}`;
      const result = await axios.post(api, filter, { headers });
      const { range } = result?.data?.data;
      let new_arr = [
        {
          id: 1,
          matrices: "Impressions",
          base_period: Number(range[0].impressions),
          comparison_period: Number(range[1].impressions),
          difference:
            Number(range[1].impressions) - Number(range[0].impressions),
        },
        {
          id: 2,
          matrices: "Clicks",
          base_period: Number(range[0].clicks),
          comparison_period: Number(range[1].clicks),
          difference: Number(range[1].clicks) - Number(range[0].clicks),
        },
        {
          id: 3,
          matrices: "Spend",
          base_period: Number(range[0].cost),
          comparison_period: Number(range[1].cost),
          difference: Number(range[1].cost) - Number(range[0].cost),
        },
        {
          id: 4,
          matrices: "Sales",
          base_period: Number(range[0].sales),
          comparison_period: Number(range[1].sales),
          difference: Number(range[1].sales) - Number(range[0].sales),
        },
        {
          id: 5,
          matrices: "Units",
          base_period: Number(range[0].units),
          comparison_period: Number(range[1].units),
          difference: Number(range[1].units) - Number(range[0].units),
        },
      ];
      setInitialData(new_arr);
      const positionMap = new Map(
        matricesData
          .filter((matrice) => matrice.toggle) // Include only items with toggle = true
          .map((matrice) => [matrice.id, matrice.position]) // Map id to position
      );
    
      // Filter and sort the data based on positionMap
      const sortedAndFilteredData = new_arr
        .filter((item) => positionMap.has(item.id)) // Include only items with a position
        .sort(
          (a, b) => (positionMap.get(a.id) ?? 0) - (positionMap.get(b.id) ?? 0) // Sort by position
        );
      setfilterData(sortedAndFilteredData);
    } catch (error) {
      appError(error);
    }
  };

  const [selectedMatrices, setSelectedMatrices] = useState<Set<string>>(
    new Set(rowsdata.map((d) => `${d?.id}-${d?.matrices}`))
  );

  const defaultColDef = {
    flex: 1,
  };
  const inputRef = React.useRef<HTMLInputElement>(null);
  const dropdownRef = React.useRef<HTMLDivElement>(null);

  const handleSwitchChange = (matrice_id: Number, matrice_name: string) => {
    setSelectedMatrices((prevSet) => {
      const newSet = new Set(prevSet);
      const Exist = matricesData.find((m) => m?.id === matrice_id)?.toggle;
      if (Exist) {
        newSet.delete(`${matrice_id}-${matrice_name}`); // Remove if already selected
        setfilterData(() =>
          rowsdata.filter((item) => newSet.has(`${item?.id}-${item?.matrices}`))
        );

        setMatricesData(
          matricesData.map((item) =>
            item.id === matrice_id ? { ...item, toggle: false } : item
          )
        );
      } else {
        newSet.add(`${matrice_id}-${matrice_name}`); // Add if not present
        setfilterData(() =>
          rowsdata.filter((item) => newSet.has(`${item?.id}-${item?.matrices}`))
        );
        setMatricesData(
          matricesData.map((item) =>
            item.id === matrice_id ? { ...item, toggle: true } : item
          )
        );
      }
      return newSet; // Return the updated Set
    });
    localStorage.setItem(
      "AdsOverviewComparisonTableSelectedMatrices",
      JSON.stringify(matricesData)
    );
  };
  const [draggedItem, setDraggedItem] = useState<Matrice | null>(null);

  const handleDragStart = (item: Matrice) => {
    setDraggedItem(item);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleDrop = (targetItem: Matrice) => {
    if (!draggedItem || draggedItem.id === targetItem.id) return;

    // for MatricesData
    const draggedIndex = matricesData.findIndex(
      (d) => d?.id === draggedItem.id
    );
    const targetIndex = matricesData.findIndex((d) => d?.id === targetItem.id);
    const updatedMatricesData = [...matricesData];
    let draggedmatriceItem = matricesData.find((d) => d?.id === draggedItem.id);
    let targetmatriceItem = matricesData.find((d) => d?.id === targetItem.id);
    const draggedmatriceIndex = matricesData.findIndex(
      (d) => d?.id === draggedItem.id
    );
    const targetmatriceIndex = matricesData.findIndex(
      (d) => d?.id === targetItem.id
    );
    if (
      draggedmatriceItem &&
      targetmatriceItem &&
      draggedmatriceIndex !== -1 &&
      targetmatriceIndex !== -1
    ) {
      updatedMatricesData[draggedIndex] = {
        ...updatedMatricesData[draggedIndex],
        position: targetIndex,
      };
      updatedMatricesData[targetIndex] = {
        ...updatedMatricesData[targetIndex],
        position: draggedIndex,
      };
      const reorderedMatricesData = updatedMatricesData.sort(
        (a, b) => a.position - b.position
      );
      setMatricesData(reorderedMatricesData);
    }
  };
  interface CustomTooltipContentProps {
    min_date: Date;
    max_date: Date;
  }

  const CustomTooltipContent: React.FC<CustomTooltipContentProps> = ({
    min_date,
    max_date,
  }) => {
    return (
      <div
        className="p-4 inline-flex flex-col items-start gap-2 rounded-2"
        style={{ backgroundColor: "#3C3C3F" }}
      >
        <div className="flex items-center gap-2 self-stretch">
          <div
            style={{
              color: "var(--Text-Primary-Grey, #97979A)",
              fontFamily: "Inter",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "1.6px",
              textTransform: "uppercase",
            }}
          >
            Data Available From
          </div>
          <div
            style={{
              color: "var(--Text-Primary-White, #FFF)",
              fontFamily: "Inter",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "1.6px",
              textTransform: "uppercase",
            }}
          >
            {formatToDDMMYYYY(min_date)}
          </div>
        </div>
        <div className="flex items-center gap-2 self-stretch">
          <div
            style={{
              color: "var(--Text-Primary-Grey, #97979A)",
              fontFamily: "Inter",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "1.6px",
              textTransform: "uppercase",
            }}
          >
            Data Available Till
          </div>
          <div
            style={{
              color: "var(--Text-Primary-White, #FFF)",
              fontFamily: "Inter",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "1.6px",
              textTransform: "uppercase",
            }}
          >
            {formatToDDMMYYYY(max_date)}
          </div>
        </div>
      </div>
    );
  };
 
  const onClearHandler = () => {
    setBaseDate({
      start: new Date("Fri Nov 01 2024 00:00:00 GMT+0530 (India Standard Time)"),
      end: new Date("Fri Nov 30 2024 00:00:00 GMT+0530 (India Standard Time)"),
    });
    setComparisonDate({
      start: new Date("Fri Oct 01 2024 00:00:00 GMT+0530 (India Standard Time)"),
      end: new Date("Fri Oct 30 2024 00:00:00 GMT+0530 (India Standard Time)"),
    });
  }

  useEffect(() => {
    if(brand_id){
    onSaveFilterHandler();
    }
    const handleClickOutside = (e: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(e.target as Node) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setRowsToggle(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [brand_id]);

  useEffect(() => {
    const positionMap = new Map(
      matricesData
        .filter((matrice) => matrice.toggle) // Include only items with toggle = true
        .map((matrice) => [matrice.id, matrice.position]) // Map id to position
    );
  
    // Filter and sort the data based on positionMap
    const sortedAndFilteredData = initialdata
      .filter((item) => positionMap.has(item.id)) // Include only items with a position
      .sort(
        (a, b) => (positionMap.get(a.id) ?? 0) - (positionMap.get(b.id) ?? 0) // Sort by position
      );
    setfilterData(sortedAndFilteredData);
    localStorage.setItem(
      "AdsOverviewComparisonTableSelectedMatrices",
      JSON.stringify(matricesData)
    );
  }, [matricesData]);

  return (
    <div className="flex ">
      <div
        className="p-6 flex w-[23%] flex-col justify-between items-start flex-shrink-0"
        style={{
          borderRight: `1px solid #EAEAED`,
          height: "calc(100vh - 72px - 52px)",
          backgroundColor: WHITE.W_100,
          boxShadow: `0px 4px 16px 6px rgba(130,130,130,0.05)`,
          position: "sticky",
        }}
      >
        <div className="flex flex-col items-start gap-6 self-stretch">
          <div
            className="flex w-full p-4 justify-center items-center gap-3"
            style={{ backgroundColor: "#F2F2F5" }}
          >
            <img
              src="/asian.png"
              className="h-[28px] flex-shrink-0"
              alt="Asian"
            />
            <div className="flex flex-col justify-center items-center gap-1 flex-grow flex-shrink-0 basis-0">
              <div
                className="self-stretch"
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "18px",
                  color: "#1C1C1E",
                }}
              >
                Asian Footwear
              </div>
              <div
                className="self-stretch"
                style={{
                  fontSize: "10px",
                  fontWeight: "500",
                  lineHeight: "10px",
                  color: "#97979A",
                  letterSpacing: "1.6px",
                }}
              >
                Amazon
              </div>
            </div>
          </div>
          <div
            className="flex flex-col items-start gap-2 self-stretch"
            style={{ position: "relative" }}
          >
            <div
              className="self-stretch"
              style={{
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "18px",
                color: "#1C1C1E",
              }}
            >
              Base Period
            </div>
            <div
              className="flex items-start self-stretch rounded-[8px]"
              style={{ border: `1px solid #EAEAED` }}
            >
              <div className="w-full flex h-[44px] px-4 py-2 justify-between items-center gap-2 ">
                {`${String(baseDate?.start.getDate()).padStart(
                  2,
                  "0"
                )}/${String(baseDate?.start.getMonth() + 1).padStart(
                  2,
                  "0"
                )}/${baseDate?.start.getFullYear()} - ${String(
                  baseDate?.end.getDate()
                ).padStart(2, "0")}/${String(
                  baseDate?.end.getMonth() + 1
                ).padStart(2, "0")}/${baseDate?.end.getFullYear()} `}
                <img
                  src={DateIcon}
                  alt="My SVG Icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => setdatename("BASE")}
                />
              </div>
            </div>
            {datename === "BASE" && (
              <div
                className=""
                style={{ position: "absolute", top: 73, zIndex: 100, right: 0 }}
              >
                <DateRangeComponent
                  startDate={baseDate?.start}
                  endDate={baseDate?.end}
                  apply={apply}
                  setdatename={setdatename}
                  maxDate={range?.max_date}
                  minDate={range?.min_date}
                />
              </div>
            )}
          </div>
          <div
            className="flex flex-col items-start gap-2 self-stretch"
            style={{ position: "relative" }}
          >
            <div
              className="self-stretch"
              style={{
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "18px",
                color: "#1C1C1E",
              }}
            >
              Comparison Period
            </div>
            <div
              className="flex items-start self-stretch rounded-[8px]"
              style={{ border: `1px solid #EAEAED` }}
            >
              <div className="w-full flex h-[44px] px-4 py-2 justify-between items-center gap-2 ">
                {`${String(ComparisonDate?.start.getDate()).padStart(
                  2,
                  "0"
                )}/${String(ComparisonDate?.start.getMonth() + 1).padStart(
                  2,
                  "0"
                )}/${ComparisonDate?.start.getFullYear()} - ${String(
                  ComparisonDate?.end.getDate()
                ).padStart(2, "0")}/${String(
                  ComparisonDate?.end.getMonth() + 1
                ).padStart(2, "0")}/${ComparisonDate?.end.getFullYear()} `}
                <img
                  src={DateIcon}
                  alt="My SVG Icon"
                  onClick={() => setdatename("COMPARISON")}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
            {datename === "COMPARISON" && (
              <div
                className=""
                style={{ position: "absolute", top: 73, zIndex: 100, right: 0 }}
              >
                <DateRangeComponent
                  startDate={ComparisonDate?.start}
                  endDate={ComparisonDate?.end}
                  apply={apply}
                  setdatename={setdatename}
                  maxDate={range.max_date}
                  minDate={range.min_date}
                />
              </div>
            )}
          </div>
        </div>
        <div className="flex items-center gap-3 self-stretch">
          <Button
            color="neutral"
            sx={{
              height: 40,
              // width: 150,
              width: "100%",
              fontSize: 14,
              fontWeight: 700,
              backgroundColor: "#FFF",
              lineHeight: "20px",
              color: "#1C1C1E",
              ":hover": {
                backgroundColor: BLACK.B_20,
              },
              borderRadius: "6px",
              border: `1px solid #EAEAED`,
            }}
            onClick={onClearHandler}
          >
            Clear Filter
          </Button>
          <Button
            // loading={lodingOnSave}
            sx={{
              height: 40,
              // width: 150,
              width: "100%",
              fontSize: 14,
              fontWeight: 700,
              backgroundColor: "#1565C0",
              lineHeight: "18px",
              color: "#FFF",
              borderRadius: 6,
            }}
            onClick={onSaveFilterHandler}
          >
            Apply Filter
          </Button>
        </div>
      </div>
      <div className="flex flex-col items-start gap-6 p-10 w-full">
        <div className="flex p-1 w-full justify-between items-center self-stretch">
          <div className="flex flex-col justify-center items-start gap-2">
            <div
              className=""
              style={{
                color: "#1C1C1E",
                fontSize: "32px",
                fontWeight: "700",
                lineHeight: "42px",
              }}
            >
              Good Morning, {full_name ? `${words[0]}` : ""}
            </div>
            <div className="flex justify-end items-center gap-2 rounded-[4px]">
              <div
                style={{
                  fontSize: "10px",
                  fontWeight: "500",
                  lineHeight: "10px",
                  letterSpacing: "1.6px",
                  textTransform: "uppercase",
                  color: "#97979A",
                }}
              >
                Last UPDATED ON {formatToDDMMYYYY(range?.max_date)}
              </div>
              <Tooltip
                title={
                  <CustomTooltipContent
                    min_date={range?.min_date}
                    max_date={range?.max_date}
                  />
                }
                placement="right"
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "16px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "8px",
                  fontSize: "12px",
                  fontWeight: "500",
                  fontStyle: "normal",
                  lineHeight: "18px",
                  color: WHITE.W_100,
                }}
              >
                <img src={Icon} alt="My SVG Icon" />
              </Tooltip>
            </div>
          </div>
          <div
            className="flex h-[42px] w-[240px] p-1 items-center"
            style={{ borderRadius: "4px", backgroundColor: "#F2F2F5" }}
          >
            <div
              className="flex w-[120px] px-4 py-2 justify-center items-center gap-2 rounded-[4px] cursor-pointer"
              style={{
                backgroundColor:
                  location.pathname === "/Adsdashboard/overview/comparison"
                    ? "#1565C0"
                    : "#F2F2F5",
              }}
              onClick={() => navigate("/Adsdashboard/overview/comparison")}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  lineHeight: "18px",
                  color:
                    location.pathname === "/Adsdashboard/overview/comparison"
                      ? "#FFF"
                      : "#B7B7B9",
                }}
              >
                Comparison
              </div>
            </div>
            <div
              className="flex w-[120px] px-4 py-2 justify-center items-center gap-2 rounded-[4px] cursor-pointer"
              style={{
                backgroundColor:
                  location.pathname === "/Adsdashboard/overview/summary"
                    ? "#1565C0"
                    : "#F2F2F5",
              }}
              onClick={() => navigate("/Adsdashboard/overview/summary")}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  lineHeight: "18px",
                  color:
                    location.pathname === "/Adsdashboard/overview/summary"
                      ? "#FFF"
                      : "#B7B7B9",
                }}
              >
                Summary
              </div>
            </div>
          </div>
        </div>

        <div
          className="flex flex-col items-start self-stretch w-full rounded-[8px]"
          style={{
            boxShadow: `0px 4px 16px 6px rgba(130,130,130,0.05)`,
            maxHeight: "calc(100vh - 72px - 230px)",
            // overflowY:"scroll"
          }}
        >
          <div className="flex p-6 justify-between items-end gap-4 self-stretch w-full">
            <div className="flex flex-col justify-center items-start gap-1 ">
              <div
                className="self-stretch"
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  lineHeight: "26px",
                  color: "#1C1C1E",
                }}
              >
                Performance Comparison
              </div>
              <div
                className="self-stretch"
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "18px",
                  color: "#97979A",
                }}
              >
                View and compare key metrics across different timeframes
              </div>
            </div>
            <div ref={inputRef} className="" style={{ position: "relative" }}>
              <Button
                color="neutral"
                sx={{
                  height: 40,
                  width: 140,
                  fontSize: 14,
                  fontWeight: 700,
                  backgroundColor: "#FFF",
                  lineHeight: "20px",
                  color: "#1C1C1E",
                  ":hover": {
                    backgroundColor: "#1565C0",
                  },
                  paddingX: "6px",
                  paddingY: 0,
                  gap: "8px",
                  borderRadius: "6px",
                  border: `1px solid #EAEAED`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  setRowsToggle(!rowsToggle);
                  // onClearFilterHandler();
                  //   setFilterToggle(false);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M4.42308 9.01434C4.00211 9.01434 3.64579 8.8685 3.35413 8.57684C3.06246 8.28517 2.91663 7.92885 2.91663 7.50788V4.42308C2.91663 4.00211 3.06246 3.64579 3.35413 3.35413C3.64579 3.06246 4.00211 2.91663 4.42308 2.91663H15.5768C15.9978 2.91663 16.3541 3.06246 16.6458 3.35413C16.9375 3.64579 17.0833 4.00211 17.0833 4.42308V7.50788C17.0833 7.92885 16.9375 8.28517 16.6458 8.57684C16.3541 8.8685 15.9978 9.01434 15.5768 9.01434H4.42308ZM4.42308 7.76434H15.5768C15.6517 7.76434 15.7132 7.74031 15.7612 7.69225C15.8093 7.6442 15.8333 7.58274 15.8333 7.50788V4.42308C15.8333 4.34822 15.8093 4.28677 15.7612 4.23871C15.7132 4.19065 15.6517 4.16663 15.5768 4.16663H4.42308C4.34822 4.16663 4.28677 4.19065 4.23871 4.23871C4.19065 4.28677 4.16663 4.34822 4.16663 4.42308V7.50788C4.16663 7.58274 4.19065 7.6442 4.23871 7.69225C4.28677 7.74031 4.34822 7.76434 4.42308 7.76434ZM4.42308 17.0833C4.00211 17.0833 3.64579 16.9375 3.35413 16.6458C3.06246 16.3541 2.91663 15.9978 2.91663 15.5768V12.5C2.91663 12.079 3.06246 11.7227 3.35413 11.431C3.64579 11.1393 4.00211 10.9935 4.42308 10.9935H15.5768C15.9978 10.9935 16.3541 11.1393 16.6458 11.431C16.9375 11.7227 17.0833 12.079 17.0833 12.5V15.5768C17.0833 15.9978 16.9375 16.3541 16.6458 16.6458C16.3541 16.9375 15.9978 17.0833 15.5768 17.0833H4.42308ZM4.42308 15.8333H15.5768C15.6517 15.8333 15.7132 15.8093 15.7612 15.7612C15.8093 15.7132 15.8333 15.6517 15.8333 15.5768V12.5C15.8333 12.4251 15.8093 12.3636 15.7612 12.3156C15.7132 12.2675 15.6517 12.2435 15.5768 12.2435H4.42308C4.34822 12.2435 4.28677 12.2675 4.23871 12.3156C4.19065 12.3636 4.16663 12.4251 4.16663 12.5V15.5768C4.16663 15.6517 4.19065 15.7132 4.23871 15.7612C4.28677 15.8093 4.34822 15.8333 4.42308 15.8333Z"
                    fill="#1C1C1E"
                  />
                </svg>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    textAlign: "center",
                    lineHeight: "18px",
                    color: "#1C1C1E",
                  }}
                >
                  Rows
                </div>
              </Button>
              {rowsToggle && (
                <div
                  ref={dropdownRef}
                  className="custom-scrollbar flex w-[227px] h-[180px] p-4 flex-col items-start gap-[23px] rounded-[8px] "
                  style={{
                    position: "absolute",
                    top: 45,
                    right: 0,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 10px 4px rgba(28, 28, 30, 0.05)",
                    zIndex: 10,
                    overflowY: "scroll",
                  }}
                >
                  <style>
                    {`
      .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
        height: 50px;
        
      }

      .custom-scrollbar::-webkit-scrollbar-track {
        background: white;
      }

      .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #F2F2F5;
        border-radius: 8px;
      }

    `}
                  </style>
                  {matricesData.length > 0 &&
                    matricesData.map((m: Matrice) => (
                      <div
                        className="flex items-center justify-between gap-2 self-stretch"
                        key={m?.matrice}
                        draggable
                        onDragStart={() => handleDragStart(m)}
                        onDragOver={handleDragOver}
                        onDrop={() => handleDrop(m)}
                      >
                        <div className="flex items-center gap-1">
                          <img
                            src={DragAndDropIcon}
                            alt="Drag And Drop Icon"
                            style={{ cursor: "pointer" }}
                          />
                          <div
                            className=""
                            style={{
                              paddingLeft: "5px",
                              color: "#1C1C1E",
                              fontSize: "14px",
                              fontWeight: "400",
                              lineHeight: "18px",
                            }}
                          >
                            {m?.matrice}
                          </div>
                        </div>
                        <Switch
                          checked={m?.toggle}
                          onChange={(event) =>
                            handleSwitchChange(m?.id, m?.matrice)
                          }
                        />
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>

          <div
            className={"ag-theme-quartz"}
            style={{ width: "100%", height: "808px", overflowY: "hidden" }}
          >
            <AgGridReact
              rowData={filterdata}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              // getRowId={()=> }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Comparison;
